import { type PaymentBreakdown } from './PaymentBreakdown';

export interface ShippingMethod {
  label: string;
  detail: string;
  amount: string;
  identifier: string;
}

export interface ShippingContact {
  countryCode?: string;
  city?: string;
  state?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  addressLine1?: string;
  addressLine2?: string;
  postalCode?: string;
  phone?: string;
}
export type ShippingContactRestricted = Pick<ShippingContact, 'countryCode' | 'city' | 'state' | 'postalCode'>;

export const UNEXPECTED_ERROR = 'UNEXPECTED';
export const ShippingErrors = ['SHIPPING_CONTACT_INVALID', 'SHIPPING_ADDRESS_UNSERVICEABLE', 'SHIPPING_UNKNOWN'];

export type ShippingErrorTypes = keyof typeof ShippingError;
export type ShippingErrorValues = (typeof ShippingError)[ShippingErrorTypes];
export const ShippingError = {
  SHIPPING_CONTACT_INVALID: 0,
  SHIPPING_ADDRESS_UNSERVICEABLE: 1,
  SHIPPING_UNKNOWN: 2,
} as const;

export const isValidShippingError = (error: ShippingErrorValues) => {
  return Object.values(ShippingError).includes(error);
};

export interface ShippingMethodSelectedUpdate {
  paymentAmount: string;
  paymentBreakdown?: PaymentBreakdown;
}

export interface BillingContactSelectedUpdate {
  paymentAmount?: string;
  paymentBreakdown?: PaymentBreakdown;
}

export interface ShippingContactSelectedUpdate {
  error?: ShippingErrorValues;
  paymentAmount?: string;
  paymentBreakdown?: PaymentBreakdown;
  shippingMethods?: ShippingMethod[];
}
